import { firebaseConfig } from './firebase';

export const environment = {
  production: true,
  firebaseConfig,
};
